import { useEffect, useRef } from "react";
import AuthenticationSection from "./sections/AuthenticationSection";
import EndpointSection from "./sections/EndpointSection";
import OverviewSection from "./sections/OverviewSection";
import SchemasSection from "./sections/SchemasSection";

export default function MainContent({ apiSpec, activeSection }) {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [activeSection]);

  const renderContent = () => {
    if (activeSection === "overview") return <OverviewSection apiSpec={apiSpec} />;
    if (activeSection === "authentication") return <AuthenticationSection apiSpec={apiSpec} />;
    if (activeSection === "schemas") return <SchemasSection apiSpec={apiSpec} />;

    if (activeSection.includes("-/")) {
      const [method, ...rest] = activeSection.split("-");
      const path = rest.join("-");
      return <EndpointSection apiSpec={apiSpec} method={method} path={path} />;
    }

    return <OverviewSection apiSpec={apiSpec} />;
  };

  return (
    <div className="main-content" ref={contentRef}>
      {renderContent()}
    </div>
  );
}
